module.exports = __webpack_public_path__ + "static/media/cover-photo-pay-wall.74496fc1.png";